import { render, staticRenderFns } from "./NextToPlayWide.vue?vue&type=template&id=bb0a4b7e"
import script from "./NextToPlayWide.vue?vue&type=script&lang=js"
export * from "./NextToPlayWide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports